import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    messages: {},
    email: "",
    product: {}
  },
  mutations: {
    translations (state, payload) {
      state.messages = payload;
    },
    setEmail (state, payload) {
      state.email = payload;
    },
    setProduct (state, payload) {
      state.product = payload;
    },
  },
  strict: true
})